import React from 'react';import ExtendedModulePage from './ExtendedModulePage';export default function TransportStopsPage(){return <ExtendedModulePage moduleKey="transport-stops"/>}
